import _objectSpread from "/app/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import getFileNameAndExtension from './getFileNameAndExtension.js';
export default function remoteFileObjToLocal(file) {
  return _objectSpread(_objectSpread({}, file), {}, {
    type: file.mimeType,
    extension: file.name ? getFileNameAndExtension(file.name).extension : null
  });
}